import { UIHeading2, UIText1, Button } from '@cian/ui-kit';
import * as React from 'react';
import clsx from 'classnames';

import { ECPDChatIdLoadingStatus } from 'shared/types/redux/cpd';

import bgImg from './assets/bg.png';
import styles from './PrelandingModalSuccessScreen.css';

interface IPrelandingModalSuccessScreenProps {
  onGoCianChat: VoidFunction;
  onModalClose: VoidFunction;
  onSuccessScreenOpen: VoidFunction;
  cpdChatIdLoadingStatus: ECPDChatIdLoadingStatus | null;
  isUserAuthenticated: boolean;
  isMobile: boolean;
}

export const PrelandingModalSuccessScreen: React.FC<IPrelandingModalSuccessScreenProps> = props => {
  const { onGoCianChat, onSuccessScreenOpen, onModalClose, cpdChatIdLoadingStatus, isUserAuthenticated, isMobile } =
    props;

  React.useEffect(() => {
    onSuccessScreenOpen();
  }, [onSuccessScreenOpen]);

  const button = isUserAuthenticated ? (
    <Button
      onClick={onGoCianChat}
      theme="fill_primary"
      disabled={cpdChatIdLoadingStatus === ECPDChatIdLoadingStatus.Loading}
      data-testid="CPDPrelandingModalGoToChat"
      fullWidth={isMobile}
      size={isMobile ? 'L' : 'M'}
    >
      Подробности — в чате Циан
    </Button>
  ) : (
    <Button
      onClick={onModalClose}
      theme="fill_primary"
      data-testid="CPDPrelandingModalConfirm"
      fullWidth={isMobile}
      size={isMobile ? 'L' : 'M'}
    >
      Буду ждать
    </Button>
  );

  const dataTestId = isUserAuthenticated ? 'CPDPrelandingModalSuccess' : 'CPDPrelandingModalSuccessAnonymous';

  return (
    <div className={clsx(styles['container'], isMobile && styles['mobile'])} data-testid={dataTestId}>
      <img className={clsx(styles['img'], isMobile && styles['mobile'])} src={bgImg} />
      <div className={styles['title']}>
        <UIHeading2>Скоро перезвоним</UIHeading2>
      </div>
      <div className={styles['text']}>
        <UIText1 color="text-secondary-default">
          С&nbsp;9&nbsp;до&nbsp;21&nbsp;по&nbsp;Мск&nbsp;менеджер позвонит вам, чтобы&nbsp;обсудить детали
        </UIText1>
      </div>
      {button}
    </div>
  );
};
